import { memo, PropsWithChildren } from 'react';
import clsx from 'clsx';
import { CrossIcon } from 'src/modules/common/icons/CrossIcon';

type Props = PropsWithChildren<{
    disabled?: boolean;
    onClick?: () => void;
}>

export const Chip = memo(({ disabled, children, onClick }: Props) => (
    <button
        type="button"
        className={clsx({
            'vss-chip': true,
            'vss-chip--disabled': disabled,
        })}
        onClick={onClick}
    >
        {children}

        <div className="vss-chip__icon">
            <CrossIcon/>
        </div>
    </button>
));
